import React from 'react';
const spiner=()=>(
  
    <div className="loader">Loading...</div>
); 
export default spiner;